import React, {useEffect, useState, useContext} from 'react';
import {marked} from 'marked';
import ChatUnderbarArea from './ChatUnderbarArea';
import Evidence from './Evidence';
import ChatGraph from './ChatGraph';
import ProcessBar from './ProcessBar';
import Spinner from './Spinner';
import { MessageContext } from './MessageContext';
import katex from "katex";
import "katex/dist/katex.min.css";

// カスタムレンダラーを設定
const renderer = new marked.Renderer();

renderer.code = (code, infostring, escaped) => {
  if (infostring === "math" || infostring === "latex") {
    return `<p>${katex.renderToString(code, { throwOnError: false })}</p>`;
  }
  return `<pre><code>${code}</code></pre>`;
};

// `marked` にカスタムレンダラーを適用
marked.setOptions({ renderer });

const AssistantUtterance = ({ message, chatHistoryId, isGood, isBad, feedback, graphs, evidences, userMessage, onSaveClick, onGoodClick, onBadClick, onFeedbackClick, addMessage, agents=[], addGraphs=[], nextQuestions=[], showSpinner=false, errMsg='' }) => {
  const { setSelectedMessage } = useContext(MessageContext);
  const [htmlContent, setHtmlContent] = useState('');
  const [isGraphRendered, setIsGraphRendered] = useState(false); 
  const renderer = new marked.Renderer();

  // KaTeX の処理を追加
  const convertMarkdownToHtml = (message) => {
    // `[ ... ]` 形式の数式を `$...$` に変換（インライン数式）
    // message = message.replace(/\[\s*(.*?)\s*\]/g, "$$$1$$");

    // Markdown を HTML に変換
    const html = marked(message);

    // 変換した HTML 内の数式を KaTeX でレンダリング
    return html.replace(/\$\$(.*?)\$\$/gs, (_, tex) =>
      katex.renderToString(tex, { throwOnError: false, displayMode: true })
    ).replace(/\$(.*?)\$/g, (_, tex) =>
      katex.renderToString(tex, { throwOnError: false, displayMode: false })
    );
  };

  useEffect(() => {
    if (message) {
      message = message.replace(/\[insert_figure_\d+\]/g, '');
      setHtmlContent(convertMarkdownToHtml(message));
    } else {
      setHtmlContent('')
    }
  }, [message])

  useEffect(() => {
    if (addMessage) {
      setHtmlContent(convertMarkdownToHtml(addMessage));
    }
  }, [addMessage])

  useEffect(() => {
    if ((graphs.length > 0 || addGraphs.length > 0) && !isGraphRendered) {
      setIsGraphRendered(true);
    }
  }, [graphs, addGraphs]);

  return (
    <div className="chat-message">
      <div className="message-sender">
        <img src="/img/chat_logo.png" alt="Profile Picture" className="icon h-[15px] w-[15px]" />
        <ProcessBar agents={agents} />
        {showSpinner ? <Spinner /> : null}
      </div>
      <div className="message-content-receive" data-chat-history-id={chatHistoryId}>
        <p dangerouslySetInnerHTML={{ __html: htmlContent }}></p>
        {isGraphRendered && <ChatGraph graphs={graphs} />}
        {errMsg != '' && <div className='py-4 text-red-500'>{errMsg}</div>}
        {addGraphs.length > 0 && <ChatGraph graphs={addGraphs} />}
        {evidences.length > 0 && <Evidence evidences={evidences} />}
        <ChatUnderbarArea
          isGood={isGood}
          isBad={isBad}
          feedback={feedback}
          chatHistoryId={chatHistoryId}
          userMessage={userMessage}
          assistantMessage={message}
          onGoodClick={onGoodClick}
          onBadClick={onBadClick}
          onSaveClick={onSaveClick}
          onFeedbackClick={onFeedbackClick}
        />
      </div>
      {nextQuestions.length > 0 && nextQuestions[0] != '' ? 
        <>
        <div className="next-question-examples">Next Question ?</div>
        <div className="first-introduction">
          {nextQuestions.map((nextQuestion, index) => (
            <div key={index} className="introduction-content" onClick={() => setSelectedMessage(nextQuestion)}>{nextQuestion}</div>
          ))
            }
          </div>
        </>
      : null}
    </div>
  )
}

export default AssistantUtterance